(function() { window.GUID_698a5bca_370a_48d9_a74c_8860afddb316 = { getGuid: function() { return "698a5bca-370a-48d9-a74c-8860afddb316"; } }; })();
var CS;
(function (CS) {
    var App;
    (function (App) {
        var Views;
        (function (Views) {
            var _Shared;
            (function (_Shared) {
                var WallSections;
                (function (WallSections) {
                    CS.Controls.Accordion.Events.Ready({
                        selector: "body",
                        childSelector: ".accordion-eventscontainoper",
                        callback: function (control, e) {
                            control.$Container.offon("click.event-box", ".event-box__header", function (e) {
                                const $target = $(e.target), $eventBox = $target.closest(".event-box"), url = $eventBox.data("url");
                                if (url != null) {
                                    CS.Nav.Go(url);
                                }
                            });
                        }
                    });
                    //CS.Controls.Accordion.Events.ContentLoaded({
                    //    selector: "body",
                    //    childSelector: ".accordion-eventscontainoper",
                    //    callback: function (control, e) {
                    //        GoogleAds.BindAds(true);
                    //    }
                    //});
                })(WallSections = _Shared.WallSections || (_Shared.WallSections = {}));
            })(_Shared = Views._Shared || (Views._Shared = {}));
        })(Views = App.Views || (App.Views = {}));
    })(App = CS.App || (CS.App = {}));
})(CS || (CS = {}));

//# sourceMappingURL=event-box.js.map
